export default __webpack_public_path__ + "static/media/amazing_i.37e42d8d.svg";